import Navigation from "Navigation";
import { WithAntdTheme } from "global/hoc";

function App() {
  return (
    <WithAntdTheme>
      <Navigation />
    </WithAntdTheme>
  );
}

export default App;
